import React, { Component } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import Translation from "../translation/translation";
// import { Link, withRouter, Redirect } from 'react-router-dom';
// import $ from 'jquery';
import Context from "../context/context";
import Comm from "../comm/comm";
import moment from "moment";

class ErrorSort extends Component {
    ResortData = null;

    constructor(props) {
        super(props);
        if (!Context.IsLogged()) {
            return;
        }

        var sid = Context.GetContext().Sid;
        this.ResortData = Comm.GetManualSortingData({ session: sid });
        var outputArticles = Comm.Articles(sid, true);

        if (outputArticles.length === 0 || this.ResortData.length === 0) {
            this.state = {
                NoData: true,
            };
        } else {
            var inputArticles = Comm.SortingInArticles({
                session: sid,
                article_id: outputArticles[0].id,
            }).in_articles;
            var inputArticle = inputArticles ? inputArticles[0].id : null;

            this.state = {
                NoData: false,
                Operators: this.ResortData,
                Operator: this.ResortData[0].id,
                Sorters: this.ResortData[0].sorters,
                Sorter: this.ResortData[0].sorters[0].id,
                OutputArticles: outputArticles,
                OutputArticle: outputArticles[0].id,
                InputArticles: inputArticles,
                InputArticle: inputArticle,
                OnDate: null,
                Quantity: 0,
            };
        }

        this.ChangeValue = this.ChangeValue.bind(this);
        this.ChangeDate = this.ChangeDate.bind(this);

        this.Save = this.Save.bind(this);
    }

    ChangeValue(e) {
        var stateData = { [e.target.name]: e.target.value };
        var sid = Context.GetContext().Sid;

        if (e.target.name === "Operator") {
            var Sorters = null;
            var Sorter = null;
            for (var i = 0; i < this.ResortData.length; i++) {
                if (this.ResortData[i].id === parseInt(e.target.value, 10)) {
                    Sorters = this.ResortData[i].sorters;
                    Sorter = this.ResortData[i].sorters[0].id;
                    break;
                }
            }
            stateData.Sorters = Sorters;
            stateData.Sorter = Sorter;
        }

        if (e.target.name === "OutputArticle") {
            stateData.InputArticles = Comm.SortingInArticles({
                session: sid,
                article_id: e.target.value,
            }).in_articles;
            stateData.InputArticle = stateData.InputArticles ? stateData.InputArticles[0].id : null;
        }

        if (e.target.name === "Quantity") {
            stateData.Quantity = parseInt(e.target.value, 10) || 0;
        }
        this.setState(stateData);
    }

    ChangeDate(date) {
        this.setState({ OnDate: date });
    }

    Save() {
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            operator: this.state.Operator,
            article_in: this.state.OutputArticle,
            article_out: this.state.InputArticle,
            sorter: this.state.Sorter,
            qty: parseFloat(this.state.Quantity),
        };

        if (this.state.OnDate != null) data.date = moment(this.state.OnDate).format("YYYYMMDD");

        Comm.SaveManualSort(data);

        this.setState({ ShowOK: true });
        setInterval(() => {
            this.setState({ ShowOK: false });
        }, 3000);
    }

    render() {
        if (Context.RenderNotOK(this.props.history)) return null;

        return this.state.NoData ? (
            <div>Enter article data</div>
        ) : Context.HasRight("rmanualresort") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("errorsort")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-6">
                            <label for="ddlOperator">{Translation.Trans("operator")}</label>
                            <select
                                id="ddlOperator"
                                className="form-control"
                                onChange={this.ChangeValue}
                                value={this.state.Operator}
                                name="Operator"
                            >
                                {this.state.Operators.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <label for="ddlSorter">{Translation.Trans("sorter")}</label>
                            <select
                                id="ddlSorter"
                                className="form-control"
                                onChange={this.ChangeValue}
                                value={this.state.Sorter}
                                name="Sorter"
                            >
                                {this.state.Sorters.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="ddlOutputArticles">{Translation.Trans("outputarticles")}</label>
                            <select
                                id="ddlOutputArticles"
                                className="form-control"
                                onChange={this.ChangeValue}
                                value={this.state.OutputArticle}
                                name="OutputArticle"
                            >
                                {this.state.OutputArticles.map((item) => (
                                    <option value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-6">
                            {this.state.InputArticle !== null
                                ? [
                                      <label for="ddlInputArticle">
                                          {Translation.Trans("inputarticles")}
                                      </label>,
                                      <select
                                          id="ddlInputArticle"
                                          className="form-control"
                                          onChange={this.ChangeValue}
                                          value={this.state.InputArticle}
                                          name="InputArticle"
                                      >
                                          {this.state.InputArticles.map((item) => (
                                              <option value={item.id}>{item.name}</option>
                                          ))}
                                      </select>,
                                  ]
                                : null}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="tbQuantity">{Translation.Trans("quantity")}</label>
                            <input
                                type="number"
                                id="tbQuantity"
                                className="form-control"
                                onChange={this.ChangeValue}
                                value={this.state.Quantity}
                                name="Quantity"
                            />
                        </div>

                        <div className="col-md-6">
                            <label for="dpDate">{Translation.Trans("date")}</label>
                            <Datetime
                                inputProps={{
                                    placeholder: "N/A",
                                    readOnly: "true",
                                    className: "form-control pointhand",
                                }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat="HH:mm:ss"
                                onChange={this.ChangeDate}
                                value={this.state.OnDate}
                                closeOnSelect="true"
                            ></Datetime>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            {Context.HasRight("rmanualresort") === true &&
                            this.state.InputArticle !== null ? (
                                <button className="btn btn-primary pull-right" onClick={this.Save}>
                                    {Translation.Trans("save")}
                                </button>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            {this.state.ShowOK ? (
                                <div className="alert alert-info">{Translation.Trans("successfulsave")}</div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default ErrorSort;



// WEBPACK FOOTER //
// ./src/pages/errorsort.js